import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface ViewAllButtonProps {
  onClick: () => void;
  className?: string;
}
export const ViewAllButton: React.FC<ViewAllButtonProps> = ({
  onClick,
  className = ''
}) => {
  return <button onClick={onClick} className={`text-blue-500 text-sm hover:text-blue-600 focus:outline-none focus:underline inline-flex items-center group transition-colors duration-200 ${className}`} aria-label="View all items" data-id="element-141">
      <span data-id="element-142">View All</span>
      <ChevronRightIcon size={16} className="ml-1 transform transition-transform duration-200 group-hover:translate-x-1" data-id="element-143" />
    </button>;
};